<template>
  <div class="main">
    <div class="title-area">
      <div class="title-effect">
        <img src="img/website/dots.svg" alt="Efeitos de bolinha" loading = “lazy”/>
      </div>
      <h3 class="title">
        Nossos<br />
        <span>pilares</span><br />
        estratégicos
      </h3>
    </div>
    <div class="pillar-slider">
      <div class="pillar-img">
        <transition name="img-fade" mode="out-in">
          <img :src="items[slide].image" alt="Pilares" :key="slide" loading = “lazy”/>
        </transition>
      </div>
      <transition name="info-fade" mode="out-in">
        <div class="pillar-info" :key="slide">
          <p class="info-title">{{ slide + 1 }}.{{ items[slide].title }}</p>

          <p class="info-text">
            {{ items[slide].text }}
          </p>

          <!-- <div class="cta">
            {{ items[slide].cta }}
          </div> -->
        </div>
      </transition>
      <div class="next-pillar" @click="nextSlide()">
        <img src="img/website/fast-forward.svg" alt="Seta para direita" loading = “lazy”/>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.main {
  font-family: "Roboto", sans-serif;
  width: 100%;
  min-height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  .pillar-slider {
    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 50%;
    margin-top: 8%;
    position: relative;
    .pillar-img {
      height: 100%;
      width: 38%;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 100%;
        height: 100%;
        object-fit: cover;
        object-position: center center;
        @media (max-width: 1024px) {
          height: 70%;
        }
      }
      .img-fade-enter-active {
        transition: all 0.3s ease;
      }
      .img-fade-leave-active {
        transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
      }
      .img-fade-enter,
      .img-fade-leave-to {
        transform: translateX(-10px);
        opacity: 0;
      }
    }
    .info-fade-enter-active {
      transition: all 0.3s ease;
    }
    .info-fade-leave-active {
      transition: all 0.5s cubic-bezier(1, 0.5, 0.8, 1);
    }
    .info-fade-enter,
    .info-fade-leave-to {
      transform: translateX(-10px);
      opacity: 0;
    }
    .pillar-info {
      height: 100%;
      width: 62%;
      padding-left: 3%;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: flex-start;
      .info-title {
        text-transform: uppercase;
        font-size: 72px;
        font-weight: 700;
        line-height: 84px;
        color: var(--blue);
        @media (max-width: 1440px) {
          font-size: 58px;
          line-height: 60px;
        }
        @media (max-width: 1024px) {
          font-size: 42px;
          line-height: 44px;
        }
      }
      .info-text {
        margin: 3% 0 6%;
        font-size: 24px;
        line-height: 38px;
        font-weight: 300;
        color: var(--gray);
        width: 80%;
        @media (max-width: 1440px) {
          font-size: 18px;
          line-height: 32px;
        }
        @media (max-width: 1024px) {
          font-size: 18px;
          line-height: 20px;
        }
      }
      .cta {
        display: inline;
      }
    }
    .next-pillar {
      background-color: var(--blue);
      width: 70px;
      height: 270px;
      position: absolute;
      right: 3%;
      top: 50%;
      transform: translateY(-50%);
      display: flex;
      justify-content: center;
      align-items: center;
      transition: all 0.3s;
      &:hover {
        cursor: pointer;
        background-color: var(--dark-blue);
        img {
          animation: forward 1s cubic-bezier(0.45, 0.91, 0.55, 0.55) infinite;
        }
      }
      @media (max-width: 1440px) {
        width: 60px;
        height: 260px;
      }
      @media (max-width: 1024px) {
        width: 50px;
        height: 250px;
      }
      @media (max-width: 768px) {
        &:hover {
          background-color: var(--blue);
          img {
            animation: none;
          }
        }
      }
    }
    @media (max-width: 768px) {
      flex-direction: column;
      margin-top: 5%;
      .pillar-img {
        width: 50%;
      }
      .pillar-info {
        margin-top: 2%;
        width: 50%;
        padding-left: 0;
        align-items: center;
        .info-text {
          width: 100%;
        }
      }
    }
  }
  @media (max-width: 480px) {
    .pillar-slider {
      flex-direction: column;
      .pillar-img,
      .pillar-info,
      .next-pillar {
        position: relative;
        width: 100%;
        transform: translate(0);
      }
      .next-pillar {
        width: 80%;
        margin: 5% auto;
        height: 45px;
        right: 0;
        order: 2;
      }
      .pillar-img {
        order: 1;
        img {
          height: 100%;
        }
      }
      .pillar-info {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        padding-left: 0;
        order: 3;
        .info-title {
          font-size: 28px;
          line-height: 30px;
        }
        .info-text {
          width: 85%;
          margin: 3% 12.5% 6%;
          font-size: 16px;
        }
        .cta {
          width: 90%;
          padding: 12px 18px;
        }
      }
    }
  }
}
</style>

<script>
export default {
  data() {
    return {
      items: [
        {
          image: "img/website/tests/pilar-1.webp",
          title: "Marketing",
          text: "Com uma lista de clientes desde o primeiro dia, as novas unidades não começam “engatinhando”, já saem andando. Nosso marketing é responsável pela inserção saudável, estratégica e dentro da regulamentação de cada Hospital do Dente.",
          cta: "Conheça como criamos",
        },
        {
          image: "img/website/tests/pilar-tecnologia.webp",
          title: "Tecnologia",
          text: "Investimos em tecnologias que facilitam a vida do franqueado. Sistema próprio, CRM, dashboards oferecem uma base concreta de informações, e em tempo real, para tomada de decisões que melhorem a experiência do paciente.",
          cta: "Como lideramos",
        },
        {
          image: "img/website/tests/pilar-comercial.webp",
          title: "Comercial",
          text: "Somos especialistas em estratégias comerciais que melhoram o processo de atração e conversão de clientes. Nossos treinamentos transformarão a sua habilidade técnica em algo vendável ao gerar valor no seu trabalho.",
          cta: "Como lideramos",
        },
      ],
      slide: 0,
    };
  },
  methods: {
    nextSlide() {
      this.slide == this.items.length - 1 ? (this.slide = 0) : (this.slide += 1);
    },
  },
};
</script>